import React, { FC, ReactNode } from 'react';
import { Box, Typography } from '@mui/material';
import colors from 'src/styles/equalution/colors';
import { useViewport, isUserFromAustralia } from 'src/lib/utils';

interface OffersModuleProps {
  title: string;
  backgroundColor?: string;
  children: ReactNode;
}

export const OffersModule: FC<OffersModuleProps> = ({
  title,
  backgroundColor = colors.OFF_WHITE,
  children,
}) => {
  const { isMobile } = useViewport();
  const isAustralianUser = isUserFromAustralia();

  if (!isAustralianUser) {
    return null;
  }

  return (
    <Box
      sx={{
        background: backgroundColor,
        borderRadius: isMobile ? '0' : '24px',
        marginBottom: isMobile ? '16px' : '0',
        padding: '32px 16px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '28px',
        alignSelf: 'center',
        width: isMobile ? '100vw' : undefined,
      }}>
      <Typography
        variant="h4"
        sx={{
          fontWeight: 700,
          color: colors.OFF_BLACK,
          fontSize: '20px',
          textAlign: 'center',
        }}>
        {title}
      </Typography>
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          gap: '32px',
          alignItems: 'center',
        }}>
        {children}
      </Box>
    </Box>
  );
};
